import React, { Fragment, useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { forgetPassword } from "../../actions/auth";
import {
  TextField,
  FormControl,
  OutlinedInput,
  Input,
  InputLabel,
  InputAdornment,
} from "@material-ui/core";

//components
// import BreadCrumb from "../../components/breadcrumb/breadcrumb";

import Alert from "../../components/alert/alert.component";

const Login = (props) => {
  const [value, setValue] = useState({
    loading: false,
    email: "",
    password: "",
    emailError: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleEmailNameChange = (e) => {
    console.log(e.target);
    const target = e.target;
    const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!regexp.test(target.value)) {
      setValue({
        email: target.value,
        emailError: "Enter Valid Email",
      });
    } else {
      setValue({
        email: target.value,
        emailError: "",
      });
    }
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    setValue({ loading: true });

    const res = await props.forgetPassword(value.email);
    if (res) {
      setValue({
        message:
          "Reset Link has been sent to your email , please check your email account ..!",
        class: "alert-success",
      });
    }
    // const res = await props.auth();

    // if (localStorage.getItem("checkout") === true) {
    //   props.history.push("/checkout");
    // }

    // if (!res) {
    //   value({ loading: false });
    // }
  };

  const { isAuth } = props._auth;
  return !isAuth && !props._auth.loading ? (
    <Fragment>
      <div className="create-an-account">
        <div className="regester-top">
          <div className="container">
            <div className="row mx-md-5">
              <header className="col-md-12" id="create-acc-header">
                {/*<strong>
                    <Link
                      className="navbar-brand"
                      to="/"
                      id="logo"
                      title="sundialhomeproducts.com"
                    >
                      Sundial
                    </Link>
                  </strong>*/}
                <span className="secure-login">
                  Forget Password <i className="fa fa-lock" />
                </span>
              </header>
            </div>
          </div>
        </div>
        <div className="create-account">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div id="acc-container">
                  <div className="create-acc-heading">
                    <h3>Forget Password</h3>
                  </div>
                  <Alert />
                  {value.message && (
                    <div
                      className={`alert ${value.class}`}
                      role="alert"
                      style={{
                        width: "100%",
                        marginBottom: "2%",
                        marginTop: "2%",
                        borderRadius: "20px",
                      }}
                    >
                      {value.message}
                    </div>
                  )}
                  <form
                    id="registerForm"
                    onSubmit={(e) => {
                      onSubmit(e);
                    }}
                  >
                    <FormControl variant="outlined" className="my-2">
                      <TextField
                        variant="outlined"
                        id="component-outlined"
                        type="email"
                        name="email"
                        maxLength={96}
                        value={value.email && value.email}
                        onChange={(e) => {
                          handleEmailNameChange(e);
                        }}
                        error={
                          value.emailError && value.emailError !== ""
                            ? true
                            : false
                        }
                        label="Email Address"
                        helperText={value.emailError && value.emailError}
                      />
                    </FormControl>
                    {/* <div className="create-acc-email">
                        <input
                          className="create-acc-inp"
                          type="text"
                          autoComplete="email"
                          onChange={(e) => {
                            value({ email: e.target.value });
                          }}
                        />
                        <span className="creat-inp-error" />
                        <span className="create-acc-placeholder"> Email</span>
                      </div> */}

                    <div className="create-acc-btn">
                      <button type="submit" className="create-acc">
                        Reset Password
                      </button>
                    </div>
                    <div className="form-footer">
                      <p className="hav-acc">
                        Don’t have an account?{" "}
                        <Link to={"/register"} id="signIn-acc">
                          Sign Up
                        </Link>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  ) : null;
};

forgetPassword.propTypes = {
  forgetPassword: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  _auth: state.auth,
});

export default connect(mapStateToProps, { forgetPassword })(Login);
